import * as React from "react";

import { proto } from "../../proto";
import { translate } from "../../constants/ErrorMessages";

export const getErrorMessage = ({
  errors,
  msg,
}: {
  errors: proto.ValidationError.IFieldViolation[];
  msg?: string;
}): string | string[] => {
  if (msg) {
    return msg;
  }

  return translate(errors).map((error) => error.msg || "");
};

const Errors = (props: {
  errors: proto.ValidationError.IFieldViolation[];
  msg?: string;
}) => {
  if (!props.errors?.length) return null;

  const { errors, msg } = props;
  const message = getErrorMessage({ errors, msg });

  return (
    <span className="error">
      {typeof message === "string" ? (
        <span>{message}</span>
      ) : (
        message.map((m, idx) => (
          <span key={`error-${idx}-${errors[idx].code}`}>
            {m}
            {errors[idx].code === "EMAIL_ALREADY_EXISTS" && (
              <a href="/auth/login?redir=/cart">
                ログイン画面にてログインして下さい。
              </a>
            )}
          </span>
        ))
      )}
    </span>
  );
};

const hasInvalidAddressError = (error?: proto.IValidationError) =>
  !!(
    error &&
    error.fieldViolations &&
    error.fieldViolations.find((e) => (e.code || "").indexOf("INVALID_") > -1)
  );

const AddressInCompleteError = ({
  error,
}: {
  error?: proto.IValidationError;
}) => {
  if (!hasInvalidAddressError(error)) {
    return null;
  }

  // unify all amazon pay address to one invalid address error
  const err = [{ code: "INVALID_AMAZON_PAY_ADDRESS" }];

  return (
    <div className="mb-15">
      <Errors
        errors={err}
        msg="※ お届け住所に問題が発生しています。変更するにはAmazonのウェブサイトでの変更が必要になります。"
      />
    </div>
  );
};

export { Errors, AddressInCompleteError };
